import React, { useState, useEffect } from "react";
import {
  ActionIcon,
  Badge,
  Modal,
  Pagination,
  Select,
  Table,
  Text,
} from "@mantine/core";
import { IconEye, IconInfoCircle } from "@tabler/icons-react";
import { IconHistory } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ObligationTranHistoryModal from "./ObligationTranHistoryModal";
import {
  formatDatetoISO,
  getComplianceBadgeColor,
  getStatusColor,
  getStatusText,
  infoColor,
  infoColorTable,
} from "./utilities";
// import lexend from "./Lexend-Black.ttf";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../redux/authSlice";
import { getActionedObligations } from "../apis/obligationApi";
import { getCookiesSession } from "../cookiesSession";
import TablePagination from "../componenets/Common/TablePagination";
import UniversalTable from "../componenets/Common/UniversalTable";

const ActionedObligations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookieData = JSON.parse(getCookiesSession("LawSignaUserDataMaster"));
  const userData = cookieData.user;
  const businessUnit = parseInt(userData.mapBusinessunit);
  const department = userData.department;
  const [ahModal, setAhModal] = useState(false);
  const [ahId, setAhId] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [configs, setConfigs] = useState({
    loading: true,
    obligations: [],
    count: 0,
  });
  const [page, setPage] = useState(1);

  useEffect(() => {
    const getObligations = async () => {
      const response = await getActionedObligations({
        department: department,
        businessUnit: businessUnit,
        page: page,
        pageSize, 
      });
      console.log(response.obligations);
      setConfigs({
        loading: false,
        obligations: response.obligations,
        count: response.count,
      });
    };
    getObligations();
  }, [page, pageSize]);

  const onViewClick = (id) => {
    navigate(`/viewobligation/${id}`);
  };

  const coloredObligationHeaders = [
  {
    label: "obligation id",
    align: "center",
    render: (row) => (
      <Text size="sm" weight={600} color="#43A3B3">{`#${row.id}`}</Text>
    ),
  },
  { label: "obligation title", key: "title" },
  { label: "second party", key: "connectedParty" },
  {
    label: "compliance",
    align: "center",
    render: (row) => (
      <Badge
        variant="light"
        radius="xl"
        color={getComplianceBadgeColor(row.compliant)}
      >
        {row.compliant}
      </Badge>
    ),
  },
  {
    label: "due date",
    render: (row) => formatDatetoISO(row.duedate),
  },
  {
    label: "actions",
    align: "right",
    render: (row) => (
      <div className="flex flex-row justify-end gap-1">
        <ActionIcon onClick={() => onViewClick(row.id)} variant="subtle">
          <IconEye size={20}  color="#1b6f8d"/>
        </ActionIcon>
        
        <ActionIcon onClick={() => {
          setAhId(row.id);
          setAhModal(true);
        }} variant="subtle">
          <IconHistory size={20}  color="#1b6f8d"/>
        </ActionIcon>

        {row.extraCol3 !== "" ? (
          <ActionIcon variant="subtle">
            <IconInfoCircle color={infoColor(row.extraCol3)} size={20} />
          </ActionIcon>
        ) : (
          <div style={{ width: 28 }} />
        )}
      </div>
    ),
  },
];

  return (
    <div>
      {/* <Text className="flex justify-center font-bold text-xl my-4">
        Actioned Obligations
      </Text> */}
      {!configs.loading && configs.obligations?.length > 0 && (
        // <>
        //   <Table striped>
        //     <thead className="text-center">
        //       <tr>
        //         {/* <th style={{ textAlign: "center" }}>select</th> */}
        //         <th style={{ textAlign: "center" }}>obligation id</th>
        //         <th style={{ textAlign: "center" }}>obligation title</th>
        //         <th style={{ textAlign: "center" }}>second party</th>
        //         <th style={{ textAlign: "center" }}>compliance</th>
        //         {/* <th style={{ textAlign: "center" }}>status</th> */}
        //         <th style={{ textAlign: "center" }}>due date</th>
        //         <th>&nbsp;</th>
        //         <th>&nbsp;</th>
        //         <th>&nbsp;</th>
        //       </tr>
        //     </thead>
        //     <tbody className="text-center">
        //       {!configs.loading &&
        //         configs.obligations?.length > 0 &&
        //         configs.obligations
                  
        //           .map((row) => {
        //             return (
        //               <tr
        //                 style={{
        //                   backgroundColor: `${infoColorTable(row.extraCol3)}`,
        //                 }}
        //                 key={row.id}
        //               >
        //                 {/* <td>
        //                   <input
        //                     type="checkbox"
        //                     id={`select-${row.id}`}
        //                     // onChange={(e) =>
        //                     //   handleCheckboxChange(row.id, e.target.checked)
        //                     // }
        //                   />
        //                 </td> */}
        //                 <td>{row.id}</td>
        //                 <td>{row.title}</td>
        //                 <td>{row.connectedParty}</td>
        //                 <td>
        //                   <Badge
        //                     variant="light"
        //                     color={getComplianceBadgeColor(row.compliant)}
        //                   >
        //                     {row.compliant}
        //                   </Badge>
        //                 </td>
        //                 {/* <td>
        //                   <Badge
        //                     variant="light"
        //                     color={getStatusColor(row.status)}
        //                   >
        //                     {getStatusText(row.status)}
        //                   </Badge>
        //                 </td> */}
        //                 <td>{formatDatetoISO(row.duedate)}</td>
        //                 <td>
        //                   <div className="flex flex-row mr-4">
        //                     <ActionIcon
        //                       onClick={() => {
        //                         onViewClick(row.id);
        //                       }}
        //                       color="white"
        //                     >
        //                       <IconEye size={24} />
        //                     </ActionIcon>
        //                     {/* )} */}
        //                   </div>
        //                 </td>
        //                 <td>
        //                   <div className="flex flex-row mr-4">
        //                     <ActionIcon
        //                       onClick={() => {
        //                         setAhId(row.id);
        //                         setAhModal(true);
        //                       }}
        //                       color="white"
        //                     >
        //                       <IconHistory size={24} />
        //                     </ActionIcon>

        //                     {/* )} */}
        //                   </div>
        //                 </td>
        //                 <td style={{ textAlign: "center" }}>
        //                   <div className="flex flex-row mr-4">
        //                     {row.extraCol3 !== "" && (
        //                       <ActionIcon color="white">
        //                         <IconInfoCircle
        //                           color={infoColor(row.extraCol3)}
        //                           size={24}
        //                         />
        //                       </ActionIcon>
        //                     )}
        //                   </div>
        //                 </td>
        //               </tr>
        //             );
        //           })}
        //     </tbody>
        //   </Table>
        //   <div className="flex flex-row justify-center my-4 gap-4">
        //     <Pagination
        //       page={page}
        //       onChange={(page) => {
        //         setPage(page);
        //       }}
        //       total={Math.ceil(configs.count / pageSize)}
        //     />
        //     <Select
        //         style={{ width: "70px" }}
        //         value={pageSize + ""}
        //         data={["10", "20", "50"]}
        //         onChange={(val) =>
        //           setPageSize(parseInt(val) )
        //         }
        //       />
        //   </div>
        // </>
        <>
    <UniversalTable
      headers={coloredObligationHeaders}
      data={configs.obligations}
      loading={configs.loading}
      // Pass the background logic here
      getRowProps={(row) => ({
        style: {
          backgroundColor: infoColorTable(row.extraCol3),
        },
      })}
    />

    <TablePagination
      totalCount={configs.count}
      page={page}
      pageSize={pageSize}
      dataLength={configs.obligations.length}
      onPageChange={(val) => setPage(val)}
      onPageSizeChange={(val) => {
        setPageSize(val);
        setPage(1);
      }}
    />
  </>
      )}
      <Modal
        opened={ahModal}
        onClose={() => {
          setAhModal(false);
          setAhId(0);
        }}
        title="oblligation action history"
        size="calc(80vw)"
      >
        <ObligationTranHistoryModal id={ahId} />
      </Modal>
    </div>
  );
};

export default ActionedObligations;
